const newRenderFreeGiftReward = (cartGoalIndex, giftMilestoneIndex) => {
        const milestone = window.tlCartGoalEmbed.milestones[giftMilestoneIndex];
        const hasAppliedProductDiscount = window.tlCartGoalEmbed.appliedDiscounts.includes(window.tlCartGoalEmbed.discountCode.product_discount);
        const hasGiftMilestone = window.tlCartGoalEmbed.milestoneIndexMapGift.get(giftMilestoneIndex) ?? []
        const giftsWithDiscount = window.tlCartGoalEmbed.giftsWithDiscount.get(giftMilestoneIndex) || [];
        const totalGiftQuantity = giftsWithDiscount.reduce((sum, gift) => sum + (gift.quantity || 1), 0);
        const milestoneClaimed = totalGiftQuantity === milestone.reward_value;
        const appliedFreeGift = window.tlCartGoalEmbed.cartGoal.auto_add_reward
        ? hasAppliedProductDiscount && hasGiftMilestone
        : hasAppliedProductDiscount && hasGiftMilestone && milestoneClaimed;
        let giftItemHTML = "";
        const giftIndexInGiftsList = window.tlCartGoalEmbed.milestoneIndexInGiftsList.get(giftMilestoneIndex);
        let giftVariants = window.tlCartGoalEmbed.gifts[giftIndexInGiftsList] || [];
        giftVariants.map((variant, variantIndex) => {
            giftItemHTML += `
                <div ${variant.available ? `onClick="window.tlCartGoalEmbed.handleChangeGift(${giftMilestoneIndex}, ${variantIndex})"` : ''}  class="tl__cart-goal__free-gift-reward-body">
                    <div style="display: flex; gap: 16px; align-items: center; ${variant.available ? '' : 'opacity:0.4; pointer-events: none;'}">
                        <div class="tl__cart-goal__product-image">
                            <img src="${variant.featured_image.src || variant.featured_image}" alt="product-image"/>
                            <span class="tl__cart-goal__product-quantity">${variant.specificQuantity}</span>
                        </div>
                        <div class="tl__cart-goal__product-image-info">
                            <p>${variant.name}</p>
                           ${variant.available ? `
                            <span><del>${window.tlCartGoalEmbed.formatMoney(variant.price, window.tlCartGoalEmbed.cartGoal.currency_format, window.tlCartGoalEmbed.cartGoal.currency_display)}</del></span>
                            <span>${window.tlCartGoalEmbed.translation.gift_modal.free_text_content}</span>
                            ` :
                            `<span>${window.tlCartGoalEmbed.translation.gift_modal.out_of_stock_msg}</span>`}
                        </div>
                    </div>
                    ${variant.available ? `<div class="tl__cart-goal__check-box tl__cart-goal__check-box-${giftMilestoneIndex} tl__cart-goal__check-box-${giftMilestoneIndex}-${variantIndex}" tl__cart-goal_data_id=${variant.id}></div>` : ``}
                </div>
            `;
        })

        const afterAchieve = window.tlCartGoalEmbed.replaceVariables(milestone.reward_description_after, milestone)
        return `
            <div style="display: flex; width: 100%;justify-content: space-between;flex-direction:column;align-items:center;gap:10px;border: 2px solid #000;padding: 15px 0 25px; border-radius: 2px">
                <div style="width: 80%">
                    <p class="tl__cart-goal__container-text-reward" style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
                </div>
                `+`
                ${(window.tlCartGoalEmbed.cartGoal.auto_add_reward && giftVariants.length) ? (appliedFreeGift ? 
                `<div style="background: ${window.tlCartGoalEmbed.sectionRewardStyle.button_selected_color}" class="tl__cart-goal__gift-noti">
                    ${window.tlCartGoalEmbed.translation.auto_apply_btn.gift}
                </div>`:`` )
                :
                (`<div 
                    style="pointer-events: ${appliedFreeGift ? 'none' : 'auto'}; 
                    background: ${appliedFreeGift ? 'var(--tl__cart-goal__section-reward__button-selected-color)' : 'var(--tl__cart-goal__section-reward__button-color)'};" 
                    class="tl__cart-goal__gift-noti" 
                    onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, ${giftMilestoneIndex})"
                >
                    <span>
                        ${appliedFreeGift 
                            ? window.tlCartGoalEmbed.translation.manual_apply_btn.gift.after_apply 
                            : window.tlCartGoalEmbed.translation.manual_apply_btn.gift.before_apply}
                    </span>
                </div>`)
                }
                `+`
            </div>
            <div class="tl__cart-goal__gift-modal-${cartGoalIndex}-${giftMilestoneIndex}">
            ${
                giftVariants.length !== 0
                    ? `<div class="tl__cart-goal__list-gifts tl__cart-goal__list-gifts-${giftMilestoneIndex}">
                            <span style="font-weight: 500; padding: 8px 0;max-height: 40px;">${window.tlCartGoalEmbed.translation.gift_modal.title} <span class="tl_selected_quantity"></span></span>
                            <div style="max-height: 300px;overflow-y: auto;width: 100%;display: flex;flex-direction: column;gap: 10px;padding: 8px 5px;margin-bottom: 4px;">
                            ${giftItemHTML}
                            </div>
                            <div id="salepify-cart-goal-block-error"></div>
                            <div style="display: flex; width: 100%;height: 60px; font-size:12px">
                                <div class="tl__cart-goal__button-cancel-gift" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, ${giftMilestoneIndex}, false)">
                                ${window.tlCartGoalEmbed.translation.gift_modal.cancel_btn}
                                </div>
                                <div class="tl__cart-goal__button-add-gift" onclick="(()=>{window.tlCartGoalEmbed.handleAddtoCart(${giftMilestoneIndex}, ${cartGoalIndex})})()">
                                ${window.tlCartGoalEmbed.translation.gift_modal.confirm_btn}
                                </div>
                            </div>
                        </div>`
                    : `<div class="tl__cart-goal__list-gifts">
                            <span style="font-weight: 600">Sorry, but there's no gift available</span>
                            <div style="display: flex; width: 100%;height: 60px">
                                <div class="tl__cart-goal__button-cancel-gift" style="width: 100%;" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, ${giftMilestoneIndex}, false)">
                                    ${window.tlCartGoalEmbed.translation.gift_modal.cancel_btn}
                                </div>
                            </div>
                        </div>`
            }
            </div>
        `;
}
Object.defineProperty(window, "tlCartGoalEmbed", {
        set(value) {
          if (value) {
            value.renderFreeGiftReward = newRenderFreeGiftReward;
          }
          Object.defineProperty(window, "tlCartGoalEmbed", {
            value,
            writable: true,
            configurable: true
          });
        },
        configurable: true
});
